/**
 * MapBox Config class - For storing constant
 */
export class MapBox {
  public static ZOOM: number = 13;
  public static API_KEY = process.env.REACT_APP_MAP_KEY || '';
}
